export default "__VITE_ASSET__8CmsaUIA__"